import React, { useContext, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateToggle } from "@features/toggledSlice";
import { Link, useNavigate } from "react-router-dom";
import { updateSidebarLogo } from "@/features/sidebarSlice";
import { doLogout, getUsername } from "@services/UserService";
import {
    activeTabHandler,
    getActiveModule,
    internationalizeNumericValue,
    setCookieData,
    checkSubModulesListPermissions,
    orderReports,
    titleCase,
    getClientId,
} from "@ts/utils";
import {
    IAdminToggleBtn,
    IChannel,
    ITitle,
    IToggle,
    ParentModule,
    SubModule,
    TReportsData,
    TSelectedReportData,
    IValueNumber,
    IClient,
    Platforms,
    IClientAccess,
    IAccess,
    TUserdata,
    Roles,
    IRevstackLayoutFilters,
} from "@ts/common-types";
import { ReactComponent as ApplicationLogo } from "@images/1DS-logo-white.svg";
import { ReactComponent as AdminSettingsIcon } from "@images/admin_settings_icon.svg";
import { ReactComponent as OverviewIcon } from "@images/overview_icon.svg";
import { ReactComponent as RulesIcon } from "@images/rules_icon.svg";
import { ReactComponent as KeywordAnalyticsIcon } from "@images/keyword_analytics_icon.svg";
import { ReactComponent as ProductAnalyticsIcon } from "@images/product_analytics_icon.svg";
import { ReactComponent as NegativeKeywordsIcon } from "@images/negative_keywords_icon.svg";
import { ReactComponent as RecommendationsIcon } from "@images/recommendations_icon.svg";
import { ReactComponent as SettingsIcon } from "@images/settings_icon.svg";
import { ReactComponent as HistoryIcon } from "@images/history_icon.svg";
import { ReactComponent as RevstackIcon } from "@images/revstack_icon.svg";
import { ReactComponent as NavigatorIcon } from "@images/navigator_icon.svg";
import { ReactComponent as ProductAnalysisIcon } from "@images/product_analysis.svg";
import { ReactComponent as CategoryAnalysisIcon } from "@images/category_analysis.svg";
import { RiRobot2Line } from "react-icons/ri";
import { useGetModulesData, usePermissionCheck } from "@hooks/AllCustomHooks";
import { Statistic } from "antd";
import { map } from "underscore";
import { setSelectedReportData } from "@/features/gridDataSlice";
import $ from "jquery";
import {
    FaBars,
    FaUser,
    FaSignOutAlt,
    FaBell,
    FaCog,
    FaPowerOff,
    FaEnvelope,
    FaAngleDown,
} from "react-icons/fa";
import {
    IoGitNetwork,
    IoWalletOutline,
    IoMenu,
    IoPieChartSharp,
} from "react-icons/io5";
import { RxDotFilled } from "react-icons/rx";
import { TbRulerMeasure } from "react-icons/tb";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { FiTarget } from "react-icons/fi";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { mainContext, UserRoles } from "@/ts/constants";
import { updateShowAdminSettingsDisplay } from "@/features/modalSlice";
import { getClientLogoUrl } from "@/ts/retrieve-data";
import { ReactComponent as PlanningIcon } from "@images/plan_icon.svg";
import oneder from "@images/1der_logo.png";
import BetaBadge from "@components/widgets/BetaBadge";
import { resetRelativeFilters } from "@/features/revstackWidgetsSlice";
interface IRoute {
    icon?: React.JSX.Element;
    condition?: boolean | number;
    title?: string;
    children?: IRoute[];
    path?: string;
    report?: any;
}

const SideBar: React.FC = () => {
    const show_client_logo = useFeatureIsOn("SHOW_CLIENT_LOGO") || false;
    const username = getUsername();
    const logoUrl = useSelector(
        (state: { sidebar: { logoUrl: string | null } }) =>
            state.sidebar.logoUrl
    );
    const activeTitle = useSelector((state: ITitle) => state.title.value);
    const toggle = useSelector((state: IToggle) => state.toggle.value);
    const { sidebarToggleItems, setSidebarToggleItems, cerbosPermissions } =
        useContext(mainContext);
    const channelWalletBalance = useSelector(
        (state: IChannel) => state.channelWalletBalance.value
    );
    const currencySymbol = useSelector(
        (state: IChannel) => state.channelCurrencySymbol.value
    );
    const selectedReportData = useSelector(
        (state: TSelectedReportData) => state.selectedReportData.value
    );


    const {
        dayparting: enableDayparting,
        buybox: enableBuybox,
        revstack: enableRevstack,
        keywordRecommendation: enableKeywordRecommendation,
        navigator: enableNavigator,
        categoryAnalysis: enableCategoryAnalysis,
        productAnalysis: enableProductAnalysis,
      } = useSelector(
        (state: { adminSettings: { value: {
          dayparting: boolean;
          buybox: boolean;
          revstack: boolean;
          keywordRecommendation: boolean;
          navigator: boolean;
          categoryAnalysis: boolean;
          productAnalysis: boolean;
        } } }) => state.adminSettings.value
      );

    const revstackChannel = useSelector(
        (state: any) => state.revstackChannel.value
    );
    const mainFilters = useSelector(
        (state: any) => state.mainFilters.value
    );
    const revstackLayoutFilters = useSelector(
        (state: { revstackLayoutFilters: { value: IRevstackLayoutFilters } }) => state.revstackLayoutFilters.value
    );

    const relativeFilters = useSelector(
        (state: any) => state.relativeFilters.value
    );

    const activeModule = getActiveModule().activeModule;

    const { hasIOTAccess, hasReportBuilderAccess, canManageAdminSettings } =
        usePermissionCheck();

    const activeClientId: number = getClientId();

    const routesData = useGetModulesData({ type: "routes" });
    const reportsData = useSelector(
        (state: TReportsData) => state.reportsData.value
    );
    const clients = useSelector(
        (state: { clients: { value: IClient[] } }) => state.clients.value
    );
    const { activeParentModule, activeSection } = getActiveModule();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const sidebarDropdown = async (title: string) => {
        const listTitle = title.toLowerCase();

        setSidebarToggleItems((prev) => ({
            ...prev,
            [`#${listTitle}-list`]:
                prev[`#${listTitle}-list`] === undefined
                    ? true
                    : !prev[`#${listTitle}-list`],
        }));

        $(`#${listTitle}-list`).toggle();
        $(`#${listTitle}-list-icon`).toggleClass("rotate");
        $(`#${listTitle}-list-icon-div`).toggleClass("rotate");
    };

    useEffect(() => {
        let timer: NodeJS.Timeout;
        switch (activeModule) {
            case ParentModule.REVSTACK:
                timer = setTimeout(() => {
                    if (sidebarToggleItems["#revstack-list"] === undefined) {
                        sidebarDropdown(ParentModule.REVSTACK);
                        sidebarDropdown(Platforms.PLANNING);
                    }
                }, 0);
                break;
            case SubModule.CAMPAIGN_BUDGET:
            case SubModule.KEYWORD_MANUAL:
                timer = setTimeout(() => {
                    if (
                        sidebarToggleItems["#recommendations-list"] ===
                        undefined
                    ) {
                        sidebarDropdown("Recommendations");
                        sidebarDropdown(Platforms.ACTIVATION);
                    }
                }, 0);
                break;
            case SubModule.REVIEW_SKU:
            case SubModule.REVIEW_BRAND:
                timer = setTimeout(() => {
                    if (sidebarToggleItems["#review-list"] === undefined) {
                        sidebarDropdown(ParentModule.REVIEW_ANALYTICS);
                        sidebarDropdown(Platforms.PLANNING);
                    }
                }, 0);
                break;
            default:
                break;
        }

        return () => clearTimeout(timer);
        // eslint-disable-next-line
    }, [activeModule]);

    useEffect(() => {
        Object.keys(sidebarToggleItems).forEach((key) => {
            if (sidebarToggleItems[key]) {
                $(key).show();
                $(`${key}-icon`).addClass("rotate");
                $(`${key}-icon-div`).addClass("rotate");
            }
        });
    }, [sidebarToggleItems]);

    useEffect(() => {
        const fetchLogo = async () => {
            const currentClientId = getClientId();
            if (currentClientId && clients && clients.length > 0) {
                const currentClient = clients.find(
                    (client) => client.id === currentClientId
                );
                if (show_client_logo) {
                    if (currentClient && currentClient.logo_url) {
                        dispatch(updateSidebarLogo(currentClient.logo_url));
                    } else {
                        const url = await fetchClientLogo(currentClientId);
                        dispatch(updateSidebarLogo(url));
                    }
                } else {
                    dispatch(updateSidebarLogo(null));
                }
            }
        };
        fetchLogo();
    }, [show_client_logo]);

    const fetchClientLogo = async (clientId: number) => {
        try {
            const url = await getClientLogoUrl(clientId);
            return url ?? null;
        } catch (e) {
            return null;
        }
    };

    const showSidebar = () =>
        dispatch(updateToggle(toggle === "toggled" ? "" : "toggled"));

    const currentEnv = process.env.VITE_NODE_ENV;

    const clientGroup = useSelector(
        (state: { activeClientGroupId: IValueNumber }) =>
            state.activeClientGroupId.value
    );

    const showNewSideBarFeature =
        useFeatureIsOn("NEW_SIDEBAR_FEATURE") || false;

    const showProductAnalysisFeature =
        useFeatureIsOn("PRODUCT_ANALYSIS_FEATURE") || false;

    const userData = useSelector((state: TUserdata) => state.userData.value);
    const userAccess = userData?.is_super_admin
        ? {
            role_slug: UserRoles.ADMIN,
            platforms: [
                Platforms.ACTIVATION,
                Platforms.CHATBOT,
                Platforms.MEASUREMENT,
                Platforms.PLANNING,
            ],
            clients: [{ client_id: activeClientId }],
        }
        : userData?.access?.find((access: IAccess) =>
            access.clients.find(
                (client: IClientAccess) => client.client_id === activeClientId
            )
        );

    const showReviewAnalyticsFeature =
        useFeatureIsOn("REVSTACK_FEATURE") || false;

    const platformAccess = userAccess
        ? userAccess?.platforms.map((platform: string) =>
            platform.toLowerCase()
        )
        : [];

    const showPlanningSection = platformAccess.includes(Platforms.PLANNING);
    const showActivationSection = platformAccess.includes(Platforms.ACTIVATION);
    const showMeasurementSection = platformAccess.includes(
        Platforms.MEASUREMENT
    );

    const showChatbotFeature = useFeatureIsOn("ONEDER_FEATURE") || false;

    const showChatbotSection =
        platformAccess.includes(Platforms.CHATBOT) && showChatbotFeature;
    // const show1derSection = useFeatureIsOn("ONEDER_FEATURE") || false;

    const showMediaPlanningFeature =
        useFeatureIsOn("MEDIA_PLANNING_FEATURE") || false;

    const routePermissions = useMemo(() => {
        const permissions = checkSubModulesListPermissions(cerbosPermissions);
        return permissions;
    }, [cerbosPermissions]);

    const routes = useMemo<IRoute[]>(() => {
        const redirectToIOT = () => {
            const isDevInstance = process.env.VITE_NODE_ENV === "local";
            const redirectUrl = isDevInstance
                ? window.location.host
                : process.env.VITE_IOT_REDIRECT;
            const redirectionData = {
                channelWalletBalance:
                    internationalizeNumericValue(channelWalletBalance),
                currencySymbol,
                selectedReportData,
                canManageAdminSettings,
                enableRevstack,
                routesData,
                reportsData,
                clientGroup,
            };

            setCookieData("redirection_data", JSON.stringify(redirectionData));
            window.location.href = redirectUrl;
        };

        const routeView = (
            route: ParentModule | SubModule,
            platform: Platforms
        ) => {
            return (
                routesData.includes(route) &&
                !routePermissions.includes(route) &&
                platformAccess.includes(platform)
            );
        };

        const revstackModulesOnClick = (
            e: React.MouseEvent<HTMLAnchorElement>,
            path: string
        ) => {
            e.preventDefault();

            navigate(`${path}`);

            dispatch(resetRelativeFilters());

        };

        const Planning = [
            {
                title: "Planning",
                icon: (
                    <a
                        // href="#"
                        onClick={() => {
                            sidebarDropdown(Platforms.PLANNING);
                        }}
                    >
                        <FiTarget id="planning_icon" fill="#989eb3" />
                        <span>Planning</span>{" "}
                        <div id="planning-list-icon-div">
                            <FaAngleDown
                                id="planning-list-icon"
                                className="sidebar-icon-after"
                            />
                        </div>
                    </a>
                ),
                condition: showPlanningSection,
                children: [
                    /*{
                        title: "Review",
                        icon: (
                            <a
                                href="javascript:void(0)"
                                onClick={() => {
                                    sidebarDropdown("Review");
                                }}
                            >
                                <MdPreview fill="#989eb3" />
                                <span>Review Analytics</span>{" "}
                                <div id="review-list-icon-div">
                                    <FaAngleDown
                                        id="review-list-icon"
                                        className="sidebar-icon-after"
                                    />
                                </div>
                            </a>
                        ),
                        condition:
                            routeView(
                                ParentModule.REVIEW_ANALYTICS,
                                Platforms.PLANNING
                            ) && showReviewAnalyticsFeature,
                        children: [
                            {
                                title: "Brand",
                                path: `/${Platforms.PLANNING}/${ParentModule.REVIEW_ANALYTICS}/${SubModule.REVIEW_BRAND}`,
                                icon: (
                                    <Link
                                        to={`/${Platforms.PLANNING}/${ParentModule.REVIEW_ANALYTICS}/${SubModule.REVIEW_BRAND}`}
                                    >
                                        <RxDotFilled className="sidebar-icon-before" />
                                        <span className="ms-3">Brand</span>
                                    </Link>
                                ),
                                condition: true,
                            },
                            {
                                title: "SKU",
                                path: `/${Platforms.PLANNING}/${ParentModule.REVIEW_ANALYTICS}/${SubModule.REVIEW_SKU}`,
                                icon: (
                                    <Link
                                        to={`/${Platforms.PLANNING}/${ParentModule.REVIEW_ANALYTICS}/${SubModule.REVIEW_SKU}`}
                                    >
                                        <RxDotFilled className="sidebar-icon-before" />
                                        <span className="ms-3">SKU</span>
                                    </Link>
                                ),
                                condition: true,
                            },
                            {
                                title: "Category Insights",
                                path: `/${Platforms.PLANNING}/${ParentModule.REVIEW_ANALYTICS}/${SubModule.CATEGORY_INSIGHTS}`,
                                icon: (
                                    <Link
                                        to={`/${Platforms.PLANNING}/${ParentModule.REVIEW_ANALYTICS}/${SubModule.CATEGORY_INSIGHTS}`}
                                    >
                                        <RxDotFilled className="sidebar-icon-before" />
                                        <span className="ms-3">Category Insights</span>
                                    </Link>
                                ),
                                condition: true,
                            },
                        ],
                    },*/
                    {
                        title: titleCase(SubModule.NAVIGATOR),
                        path: `/${Platforms.PLANNING}/${SubModule.NAVIGATOR}`,
                        icon: (
                            <Link
                                to={`/${Platforms.PLANNING}/${SubModule.NAVIGATOR}`}
                                onClick={(e) => revstackModulesOnClick(e, `/${Platforms.PLANNING}/${SubModule.NAVIGATOR}`)}
                            >
                                <NavigatorIcon fill="#989eb3" />
                                <span>{titleCase(SubModule.NAVIGATOR)}</span>
                            </Link>
                        ),
                        condition: showReviewAnalyticsFeature 
                        && enableNavigator 
                        && routeView(SubModule.NAVIGATOR, Platforms.PLANNING)
                    },
                    {
                        title: titleCase(SubModule.CATEGORY_ANALYSIS),
                        path: `/${Platforms.PLANNING}/${SubModule.CATEGORY_ANALYSIS}`,
                        icon: (
                            <Link
                                to={`/${Platforms.PLANNING}/${SubModule.CATEGORY_ANALYSIS}`}
                                onClick={(e) => revstackModulesOnClick(e, `/${Platforms.PLANNING}/${SubModule.CATEGORY_ANALYSIS}`)}
                            >
                                <CategoryAnalysisIcon fill="#989eb3" />
                                <span>
                                    {titleCase(SubModule.CATEGORY_ANALYSIS)}
                                </span>
                            </Link>
                        ),
                        condition: showReviewAnalyticsFeature
                        && enableCategoryAnalysis
                        && routeView(SubModule.CATEGORY_ANALYSIS, Platforms.PLANNING),
                    },
                    {
                        title: titleCase(SubModule.PRODUCT_ANALYSIS),
                        path: `/${Platforms.PLANNING}/${SubModule.PRODUCT_ANALYSIS}`,
                        icon: (
                            <Link
                                to={`/${Platforms.PLANNING}/${SubModule.PRODUCT_ANALYSIS}`}
                                onClick={(e) => revstackModulesOnClick(e, `/${Platforms.PLANNING}/${SubModule.PRODUCT_ANALYSIS}`)}
                            >
                                <ProductAnalysisIcon fill="#989eb3" />
                                <span>
                                    {titleCase(SubModule.PRODUCT_ANALYSIS)}
                                </span>
                                <BetaBadge
                                    position="absolute"
                                    className="py-1 border border-dark"
                                />
                            </Link>
                        ),
                        condition: showProductAnalysisFeature 
                        && enableProductAnalysis
                        && routeView(SubModule.PRODUCT_ANALYSIS, Platforms.PLANNING),
                    },
                    {
                        title: titleCase(ParentModule.REVSTACK),
                        path: `/${Platforms.PLANNING}/${ParentModule.REVSTACK}`,
                        icon: (
                            <a
                                href="#"
                                onClick={() => {
                                    sidebarDropdown(ParentModule.REVSTACK);
                                }}
                            >
                                <RevstackIcon fill="#989eb3" />
                                <span>Custom Dashboards</span>{" "}
                                <div id="revstack-list-icon-div">
                                    <FaAngleDown
                                        id="revstack-list-icon"
                                        className="sidebar-icon-after"
                                    />
                                </div>
                            </a>
                        ),
                        condition:
                            routeView(
                                ParentModule.REVSTACK,
                                Platforms.PLANNING
                            ) &&
                            reportsData.revstack.length &&
                            enableRevstack,
                        children: map(
                            orderReports(reportsData.revstack), // sort reports by report_order_id
                            (report, index) => ({
                                title:
                                    report.report_name ||
                                    `Custom Report - ${index + 1}`,
                                path: `/${Platforms.PLANNING}/${ParentModule.REVSTACK}/${report.report_id}`,
                                icon: (
                                    <Link
                                        to={`/${Platforms.PLANNING}/${ParentModule.REVSTACK}/${report.report_id}`}
                                    >
                                        <RxDotFilled className="sidebar-icon-before" />
                                        <span className="ms-3">
                                            {report.report_name ||
                                                `Custom Report - ${index + 1
                                                }`}
                                        </span>
                                    </Link>
                                ),
                                condition: true,
                                report,
                            })
                        ),
                    },
                ],
            },
        ];

        const Measurement = [
            {
                title: "Measurement",
                icon: (
                    <a
                        href="#"
                        onClick={() => {
                            sidebarDropdown(Platforms.MEASUREMENT);
                        }}
                    >
                        <TbRulerMeasure id="measurement_icon" fill="#989eb3" />
                        <span>Measurement</span>{" "}
                        <div id="measurement-list-icon-div">
                            <FaAngleDown
                                id="measurement-list-icon"
                                className="sidebar-icon-after"
                            />
                        </div>
                    </a>
                ),
                condition: showMeasurementSection,
                children: [
                    /**
                     * !Note
                     * * currently we have no specific condition for routeView for IOT
                     * * But once we have implmented priveleges then accordingly we will adde it to the routeView
                     */

                    /* {
                        title: "Insights on Tap<",
                        path: "",
                        icon: (
                            <a role="button" onClick={redirectToIOT}>
                                <FaEnvelope fill="#989eb3" />
                                <span>Insights on Tap</span>
                            </a>
                        ),
                        condition: hasIOTAccess,
                    }, */
                    {
                        title: "Revscout",
                        path: "", //`/${ParentModule.REPORTS_BUILDER}`,
                        icon: (
                            <a
                                href={`${process.env.VITE_NODE_ENV === "local"
                                    ? window.location.host
                                    : process.env.VITE_REPORTS_BUILDER_HOST
                                    }/dashboard/list`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <IoPieChartSharp fill="#989eb3" />
                                <span>Revscout</span>
                            </a>
                        ),
                        condition: hasReportBuilderAccess,
                    },
                ],
            },
        ];

        const Activation = [
            {
                title: "Activation",
                icon: (
                    <a
                        href="#"
                        onClick={() => {
                            sidebarDropdown(Platforms.ACTIVATION);
                        }}
                    >
                        <AiOutlineCheckCircle
                            id="activation_icon"
                            fill="#989eb3"
                        />
                        <span>Activation</span>{" "}
                        <div id="activation-list-icon-div">
                            <FaAngleDown
                                id="activation-list-icon"
                                className="sidebar-icon-after"
                            />
                        </div>
                    </a>
                ),
                condition: showActivationSection,
                children: [
                    {
                        title: titleCase(ParentModule.PERFORMANCE_OVERVIEW),
                        path: `/${Platforms.ACTIVATION}/${ParentModule.PERFORMANCE_OVERVIEW}`,
                        icon: (
                            <Link
                                to={`/${Platforms.ACTIVATION}/${ParentModule.PERFORMANCE_OVERVIEW}`}
                                onClick={() => activeTabHandler("overview")}
                            >
                                <OverviewIcon fill="#989eb3" />
                                <span>
                                    {titleCase(
                                        ParentModule.PERFORMANCE_OVERVIEW
                                    )}
                                </span>
                            </Link>
                        ),
                        condition: routeView(
                            ParentModule.PERFORMANCE_OVERVIEW,
                            Platforms.ACTIVATION
                        ),
                    },
                    {
                        title: "Rules",
                        path: `/${Platforms.ACTIVATION}/${ParentModule.RULES}`,
                        icon: (
                            <Link
                                to={`/${Platforms.ACTIVATION}/${ParentModule.RULES}`}
                            >
                                <RulesIcon fill="#989eb3" />
                                <span>Rules</span>
                            </Link>
                        ),
                        condition: routeView(
                            ParentModule.RULES,
                            Platforms.ACTIVATION
                        ),
                    },
                    {
                        title: "Search Term Analytics",
                        path: `/${Platforms.ACTIVATION}/${ParentModule.KEYWORD_ANALYTICS}`,
                        icon: (
                            <Link
                                to={`/${Platforms.ACTIVATION}/${ParentModule.KEYWORD_ANALYTICS}`}
                            >
                                <KeywordAnalyticsIcon fill="#989eb3" />
                                <span>Search Term Analytics</span>
                            </Link>
                        ),
                        condition: routeView(
                            ParentModule.KEYWORD_ANALYTICS,
                            Platforms.ACTIVATION
                        ),
                    },
                    {
                        title: "Product Analytics",
                        path: `/${Platforms.ACTIVATION}/${ParentModule.PRODUCT_ANALYTICS}`,
                        icon: (
                            <Link
                                to={`/${Platforms.ACTIVATION}/${ParentModule.PRODUCT_ANALYTICS}`}
                            >
                                <ProductAnalyticsIcon fill="#989eb3" />
                                <span>Product Analytics</span>
                            </Link>
                        ),
                        condition: routeView(
                            ParentModule.PRODUCT_ANALYTICS,
                            Platforms.ACTIVATION
                        ),
                    },
                    {
                        title: "Negative Keywords",
                        path: `/${Platforms.ACTIVATION}/${ParentModule.NEGATIVE_KEYWORDS}`,
                        icon: (
                            <Link
                                to={`/${Platforms.ACTIVATION}/${ParentModule.NEGATIVE_KEYWORDS}`}
                            >
                                <NegativeKeywordsIcon
                                    id="negative-keywords-icon"
                                    fill="#989eb3"
                                />
                                <span>Negative Keywords</span>
                            </Link>
                        ),
                        condition: routeView(
                            ParentModule.NEGATIVE_KEYWORDS,
                            Platforms.ACTIVATION
                        ),
                    },
                    {
                        title: "Recommendations",
                        icon: (
                            <a
                                href="#"
                                onClick={() => {
                                    sidebarDropdown("Recommendations");
                                }}
                            >
                                <RecommendationsIcon
                                    id="recommendation_icon"
                                    fill="#989eb3"
                                />
                                <span>Recommendations</span>{" "}
                                <div id="recommendations-list-icon-div">
                                    <FaAngleDown
                                        id="recommendations-list-icon"
                                        className="sidebar-icon-after"
                                    />
                                </div>
                            </a>
                        ),
                        condition:
                            routeView(
                                ParentModule.KEYWORD_RECOMMENDATIONS,
                                Platforms.ACTIVATION
                            ) ||
                            routeView(
                                ParentModule.CAMPAIGN_RECOMMENDATIONS,
                                Platforms.ACTIVATION
                            ),
                        children: [
                            {
                                title: "Keywords",
                                path: `/${Platforms.ACTIVATION}/${ParentModule.KEYWORD_RECOMMENDATIONS}/${SubModule.KEYWORD_MANUAL}`,
                                icon: (
                                    <Link
                                        to={`/${Platforms.ACTIVATION}/${ParentModule.KEYWORD_RECOMMENDATIONS}/${SubModule.KEYWORD_MANUAL}`}
                                    >
                                        <RxDotFilled className="sidebar-icon-before" />
                                        <span className="ms-3">Keywords</span>
                                    </Link>
                                ),
                                condition:
                                    routeView(
                                        ParentModule.KEYWORD_RECOMMENDATIONS,
                                        Platforms.ACTIVATION
                                    ) && enableKeywordRecommendation,
                            },
                            {
                                title: "Campaigns",
                                path: `/${Platforms.ACTIVATION}/${ParentModule.CAMPAIGN_RECOMMENDATIONS}/${SubModule.CAMPAIGN_BUDGET}`,
                                icon: (
                                    <Link
                                        to={`/${Platforms.ACTIVATION}/${ParentModule.CAMPAIGN_RECOMMENDATIONS}/${SubModule.CAMPAIGN_BUDGET}`}
                                    >
                                        <RxDotFilled className="sidebar-icon-before" />
                                        <span className="ms-3">Campaigns</span>
                                    </Link>
                                ),
                                condition: routeView(
                                    ParentModule.CAMPAIGN_RECOMMENDATIONS,
                                    Platforms.ACTIVATION
                                ),
                            },
                        ],
                    },
                    {
                        title: titleCase(ParentModule.COMMON_REPORTS, true),
                        path: `/${Platforms.ACTIVATION}/${ParentModule.COMMON_REPORTS}`,
                        icon: (
                            <a
                                href="#"
                                onClick={() => {
                                    sidebarDropdown(
                                        titleCase(ParentModule.COMMON_REPORTS, true)
                                    );
                                }}
                            >
                                <RevstackIcon fill="#989eb3" />
                                <span>Common Reports</span>{" "}
                                <div id="common-reports-list-icon-div">
                                    <FaAngleDown
                                        id="common-reports-list-icon"
                                        className="sidebar-icon-after"
                                    />
                                </div>
                            </a>
                        ),
                        condition:
                            routeView(
                                ParentModule.COMMON_REPORTS,
                                Platforms.ACTIVATION
                            ) && reportsData.common.length,
                        children: map(
                            orderReports(reportsData.common), // sort reports by report_order_id
                            (report, index) => ({
                                title:
                                    report.report_name ||
                                    `Report - ${index + 1}`,
                                path: `/${Platforms.ACTIVATION}/${ParentModule.COMMON_REPORTS}/${report.report_id}`,
                                icon: (
                                    <Link
                                        to={`/${Platforms.ACTIVATION}/${ParentModule.COMMON_REPORTS}/${report.report_id}`}
                                    >
                                        <RxDotFilled className="sidebar-icon-before" />
                                        <span className="ms-3">
                                            {report.report_name ||
                                                `Report - ${index + 1}`}
                                        </span>
                                    </Link>
                                ),
                                condition: true,
                                report,
                            })
                        ),
                    },
                    {
                        title: "History",
                        path: `/${Platforms.ACTIVATION}/${ParentModule.CHANGE_LOG}`,
                        icon: (
                            <Link
                                to={`/${Platforms.ACTIVATION}/${ParentModule.CHANGE_LOG}`}
                            >
                                <HistoryIcon fill="#989eb3" />
                                <span>
                                    {titleCase(ParentModule.CHANGE_LOG)}
                                </span>
                            </Link>
                        ),
                        condition: routeView(
                            ParentModule.CHANGE_LOG,
                            Platforms.ACTIVATION
                        ),
                    },
                    {
                        title: titleCase(SubModule.MEDIA_PLANNING),
                        path: `/${Platforms.ACTIVATION}/${SubModule.MEDIA_PLANNING}`,
                        icon: (
                            <Link
                                to={`/${Platforms.ACTIVATION}/${SubModule.MEDIA_PLANNING}`}
                            >
                                <PlanningIcon fill="#989eb3" />
                                <span>
                                    {titleCase(SubModule.MEDIA_PLANNING)}
                                </span>
                            </Link>
                        ),
                        condition: showMediaPlanningFeature,
                    },
                ],
            },
        ];
        const userRole: string = userAccess ? userAccess.role_slug : "user";
        return showNewSideBarFeature
            ? [
                ...Planning,
                ...Activation,
                ...Measurement,
                {
                    title: "Integrations",
                    path: `/${ParentModule.INTEGRATIONS}`,
                    icon: (
                        <Link to={`/${ParentModule.INTEGRATIONS}`}>
                            <IoGitNetwork fill="#989eb3" />
                            <span>
                                {titleCase(ParentModule.INTEGRATIONS)}
                            </span>
                        </Link>
                    ),
                    condition: userRole !== Roles.READONLY,
                },
                {
                    title: titleCase(ParentModule.SETTINGS),
                    path: `/${ParentModule.SETTINGS}/general`,
                    icon: (
                        <Link to={`/${ParentModule.SETTINGS}/general`}>
                            <SettingsIcon fill="#989eb3" />
                            <span>{titleCase(ParentModule.SETTINGS)}</span>
                        </Link>
                    ),
                    condition: userRole !== Roles.READONLY,
                },
                {
                    title: "1der ai",
                    path: `/${ParentModule.ONEDER}`,
                    icon: (
                        <Link to={`/${ParentModule.ONEDER}`}>
                            <img
                                src={oneder}
                                height={23}
                                width={23}
                                style={{
                                    marginRight: "15px",
                                    textAlign: "center",
                                    lineHeight: "30px",
                                    borderRadius: "4px",
                                }}
                                alt="1der ai"
                            />
                            <span>1der ai</span>
                        </Link>
                    ),
                    condition: showChatbotSection,
                },
                //   {
                //       title: "Ask AI",
                //       path: `/${ParentModule.CHATBOT}`,
                //       icon: (
                //           <Link to={`/${ParentModule.CHATBOT}`}>
                //               <RiRobot2Line fill="#989eb3" />
                //               <span>Ask AI</span>
                //           </Link>
                //       ),
                //       condition: showChatbotSection,
                //   },
            ]
            : [
                ...Activation[0].children,
                ...Planning[0].children,
                ...Measurement[0].children,
                {
                    title: titleCase(ParentModule.SETTINGS),
                    path: `/${ParentModule.SETTINGS}`,
                    icon: (
                        <Link to={`/${ParentModule.SETTINGS}`}>
                            <SettingsIcon fill="#989eb3" />
                            <span>{titleCase(ParentModule.SETTINGS)}</span>
                        </Link>
                    ),
                    condition: true,
                },
                {
                    title: titleCase(ParentModule.INTEGRATIONS),
                    path: `/${ParentModule.INTEGRATIONS}`,
                    icon: (
                        <Link to={`/${ParentModule.INTEGRATIONS}`}>
                            <IoGitNetwork fill="#989eb3" />
                            <span>
                                {titleCase(ParentModule.INTEGRATIONS)}
                            </span>
                        </Link>
                    ),
                    condition: true,
                },
                {
                    title: "1der ai",
                    path: `/${ParentModule.ONEDER}`,
                    icon: (
                        <Link to={`/${ParentModule.ONEDER}`}>
                            <img src={oneder} alt="1der ai" />
                            <span>1der ai</span>
                        </Link>
                    ),
                    condition: showChatbotSection,
                },
                //   {
                //       title: "Ask AI",
                //       path: `/${ParentModule.CHATBOT}`,
                //       icon: (
                //           <Link to={`/${ParentModule.CHATBOT}`}>
                //               <RiRobot2Line fill="#989eb3" />
                //               <span>Ask AI</span>
                //           </Link>
                //       ),
                //       condition: showChatbotSection,
                //   },
            ];
    }, [
        routesData,
        reportsData,
        enableRevstack,
        enableKeywordRecommendation,
        showNewSideBarFeature,
        hasIOTAccess,
        hasReportBuilderAccess,
        showPlanningSection,
        showActivationSection,
        showMeasurementSection,
        channelWalletBalance,
        clientGroup,
        currencySymbol,
        canManageAdminSettings,
        selectedReportData,
        setSidebarToggleItems,
        cerbosPermissions,
        showReviewAnalyticsFeature,
        showMediaPlanningFeature,
        showChatbotSection,
    ]);

    const renderMenu = (
        items: IRoute[],
        listId: string,
        isChildElem = true
    ) => (
        <ul
            id={listId}
            className="list-unstyled"
            style={
                isChildElem
                    ? {
                        display: "none",
                    }
                    : {}
            }
        >
            {items.map((item) => {
                const {
                    icon,
                    condition,
                    children,
                    title: routeTitle,
                    report,
                } = item;

                if (!condition) {
                    return null;
                }

                /**
                 * !Note The below condtions for sku and brand selection is added because the dispatched title or
                 * activeTitle is different from the routeTitle,hence it is added temporarily untill this logic is refactored
                 */
                const isActive =
                    (activeTitle === "Review Analytics For SKU" &&
                        routeTitle
                            .toLowerCase()
                            .includes(SubModule.REVIEW_SKU)) ||
                    (activeTitle === "Review Analytics For My Brand" &&
                        routeTitle
                            .toLowerCase()
                            .includes(SubModule.REVIEW_BRAND)) ||
                    (["Revstack", "Common Reports"].includes(activeTitle) &&
                        report
                        ? selectedReportData.report_id === report.report_id
                        : activeTitle === routeTitle ||
                        activeParentModule === routeTitle.toLowerCase() ||
                        activeParentModule.split("-")[0] ===
                        routeTitle.toLowerCase());

                // Condition to check if new side bar feature flag is true, if not rendering old side bar menu.
                return (
                    <li
                        key={`${routeTitle}`}
                        id={`${routeTitle.toLowerCase()}`}
                        className={`sidebar-dropdown my-1 ${(activeSection === routeTitle.toLowerCase() ||
                            isActive) &&
                            "active"
                            }`}
                        onClick={() => {
                            report
                                ? dispatch(setSelectedReportData(report))
                                : null;
                        }}
                    >
                        {icon}
                        {children && children.length > 0 && (
                            <div className="sidebar-submenu">
                                {renderMenu(
                                    children,
                                    `${routeTitle.toLowerCase()}-list`
                                )}
                            </div>
                        )}
                    </li>
                );
            })}
        </ul>
    );

    return (
        <div className="sidebar-container">
            <div
                id="show-sidebar"
                className="btn btn-sm btn-dark"
                onClick={showSidebar}
                onKeyDown={showSidebar}
            >
                <FaBars />
            </div>

            <nav id="sidebar" className="sidebar-wrapper">
                <div className="sidebar-content">
                    <div className="sidebar-brand">
                        <a href="#">
                            {logoUrl && show_client_logo ? (
                                <img
                                    src={logoUrl}
                                    alt="Client Logo"
                                    style={{
                                        height: "inherit",
                                        width: "75%",
                                        maxHeight: "40px",
                                        objectFit: "contain",
                                    }}
                                    onError={(e) => {
                                        // If client logo fails to load, fall back to default logo
                                        e.currentTarget.style.display = "none";
                                        const defaultLogo =
                                            e.currentTarget.parentNode?.querySelector(
                                                ".default-logo"
                                            );
                                        if (defaultLogo) {
                                            (
                                                defaultLogo as HTMLElement
                                            ).style.display = "block";
                                        }
                                    }}
                                />
                            ) : <ApplicationLogo
                                className="default-logo d-inline-flex"
                                height="inherit"
                                width="75%"
                            />}

                            {currentEnv !== "production" && (
                                <span
                                    id="current-instance-span"
                                    className="badge border bg-warning text-dark"
                                >
                                    {currentEnv}
                                </span>
                            )}
                        </a>
                        <div id="close-sidebar">
                            <IoMenu
                                onClick={showSidebar}
                                style={{ fontSize: "26px" }}
                            />
                        </div>
                    </div>
                    <div className="sidebar-header">
                        <div className="user-pic text-white circle text-center h-100">
                            <FaUser style={{ fontSize: "28px" }} />
                        </div>
                        <div className="user-info">
                            <span className="user-name">{username}</span>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <div
                                    className="anchor-class user-status"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                    onClick={() => doLogout()}
                                    onKeyUp={() => doLogout()}
                                >
                                    <FaSignOutAlt
                                        style={{
                                            fontSize: "15px",
                                            color: "#5cb85c",
                                        }}
                                    />
                                    <span className="ms-1">Logout</span>
                                </div>
                                {canManageAdminSettings && (
                                    <div
                                        className="anchor-class user-status mt-2 d-flex"
                                        onClick={() => {
                                            dispatch(
                                                updateShowAdminSettingsDisplay(
                                                    true
                                                )
                                            );
                                            navigate(
                                                `/${ParentModule.ADMIN_SETTINGS}/settings/general`
                                            );
                                        }}
                                    >
                                        <AdminSettingsIcon
                                            fill="#ECF2FF"
                                            width="15"
                                            height="15"
                                        />
                                        <span style={{ marginLeft: "5px" }}>
                                            Admin Settings
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div
                        className={`wallet-balance ${showActivationSection ? "" : "d-none"
                            }`}
                    >
                        <Statistic
                            valueStyle={{
                                color: "white",
                                marginLeft: "40px",
                                fontSize: "20px",
                            }}
                            title={
                                <div>
                                    <IoWalletOutline
                                        style={{
                                            fontSize: "24px",
                                            marginRight: "15px",
                                            color: "#989eb3",
                                        }}
                                    />
                                    <span
                                        style={{
                                            color: "#989eb3",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Wallet Balance
                                    </span>
                                </div>
                            }
                            value={
                                channelWalletBalance
                                    ? `${currencySymbol}${internationalizeNumericValue(
                                        channelWalletBalance
                                    )}`
                                    : "N/A"
                            }
                            precision={2}
                        />
                    </div>

                    <div className="sidebar-menu">
                        {renderMenu(routes, `main-list`, false)}
                    </div>
                </div>
                <div className="sidebar-footer pt-2 d-none">
                    <a
                        data-bs-toggle="collapse"
                        href="#notifications"
                        role="button"
                        aria-expanded="false"
                        aria-controls="notifications"
                    >
                        <FaBell className="fs-5" />
                        <span className="badge rounded-pill bg-warning notification text-dark">
                            3
                        </span>
                    </a>
                    <a href="#">
                        <FaCog className="fs-5" />
                    </a>
                    <a href="#">
                        <FaPowerOff className="fs-5" />
                    </a>
                </div>
                <h6 className="text-secondary mb-3 text-center">
                    Version - {__APP_VERSION__}
                </h6>
            </nav>
        </div>
    );
};

export default SideBar;
